import { Box, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generateRandomString } from '../../../../utils';
import useToast from '../../../../hooks/useToast';
import IconGenItem from '../../../../components/material-ui/IconGenItem';
import CusButton from '../../../../components/material-ui/CusButton';
import CusInput from '../../../../components/material-ui/CusInput';
import { API_CASINO } from '../../../../api/casino';

export default function ApiSetting({ casinoId }) {
  const { t } = useTranslation();
  const { successToast } = useToast();
  const { errorToast } = useToast();
  const MIN_LENGTH = 40;
  const [apiKey, setApiKey] = useState('');

  useEffect(() => {
    API_CASINO.rabittMq
      .keyGet({ casinoId })
      .then((e) => {
        const data = e.data.data;
        const gameApiKey = data.gameApiKey;
        if (gameApiKey) setApiKey(gameApiKey);
      })
      .catch(console.error);
  }, [casinoId]);

  const generateApiKey = () => {
    setApiKey(generateRandomString(MIN_LENGTH));
  };

  const onSaveClick = () => {
    if (!apiKey.length) {
      errorToast(t('Please enter your API KEY'));
      return;
    }

    if (apiKey.length < MIN_LENGTH) {
      errorToast(t('Minimum length: х characters', { length: MIN_LENGTH }));
      return;
    }

    API_CASINO.rabittMq
      .keySet({ casinoId, gameApiKey: apiKey })
      .then(() => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  return (
    <Stack gap={2.5}>
      <Typography component={'span'} fontWeight={600}>
        {t('Authorization of API Requests from the Gaming Website')}
      </Typography>

      <Stack gap={2}>
        <Stack gap={1} direction={'row'}>
          <Box width={'100%'}>
            <CusInput
              label={'API KEY'}
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              tooltipText={t('Minimum length: х characters', { length: MIN_LENGTH })}
              isCopyClick
              width={'auto'}
              isRow
            />
          </Box>

          <IconGenItem onGenerate={generateApiKey} tooltipText={'Auto generation API KEY'} />
        </Stack>
        <CusButton
          boxProps={{ ml: 'auto' }}
          variant="outlined"
          text="Save API KEY"
          onClick={onSaveClick}
        />
      </Stack>
    </Stack>
  );
}
